import sparkleSrc from "./assets/sparkle.svg";
import type { AskTigerSparkleProps } from "./AskTigerSparkle.types";

/**
 * The Ask Tiger brand mark: tigeragentdemo's four-point ribbon sparkle. The artwork is vendored
 * once as `assets/sparkle.svg` and reused by the sparkle, the logo, and the web favicon.
 */
export function AskTigerSparkle({ size = 16, className }: AskTigerSparkleProps) {
  return (
    <img
      src={sparkleSrc}
      width={size}
      height={size}
      alt=""
      aria-hidden="true"
      className={className}
    />
  );
}
